import * as R from 'ramda';
import React, { useState, useEffect } from 'react';
// helpers/constants
import * as G from '../../helpers';
// ui
import { Box, scrollableContainerCss4px } from '../../ui';
// component/editable-box
import { Textarea } from './ui';
//////////////////////////////////////////////////

const EditableBox = (props) => {
  const {
    value,
    boxStyles,
    allowEmpty,
    placeholder,
    wrapperStyles,
    onBlurCallback,
    textareaStyles,
  } = props;

  const [text, setText] = useState(value);

  const [isTextFocused, setIsTextFocused] = useState(false);

  useEffect(() => {
    setText(value);
  }, [value]);

  const withPlaceholder = G.isNotNilAndNotEmpty(placeholder);

  const onBlurHandler = (newValue) => {
    setIsTextFocused(false);

    const trimmedValue = R.trim(newValue);

    if (G.isAllTrue(withPlaceholder, R.not(allowEmpty), G.isNilOrEmpty(trimmedValue))) setText(value);

    G.callFunctionWithArgs(onBlurCallback, trimmedValue);
  };

  const trimmedText = R.trim(R.or(text, ''));

  const boxStylesToUse = R.and(withPlaceholder, G.isNilOrEmpty(trimmedText))
    ? R.mergeRight(boxStyles, { fontStyle: 'italic', color: G.getTheme('colors.dark.grey') })
    : boxStyles;

  return (
    <Box {...wrapperStyles}>
      {
        R.not(isTextFocused) &&
        <Box {...boxStylesToUse} css={scrollableContainerCss4px} onClick={() => setIsTextFocused(true)}>
          {R.or(trimmedText, placeholder)}
        </Box>
      }
      {
        isTextFocused &&
        <Textarea
          {...textareaStyles}
          value={text}
          autoFocus={true}
          onChange={(event) => setText(G.getEventTargetValue(event))}
          onBlur={(event) => onBlurHandler(G.getEventTargetValue(event))}
        />
      }
    </Box>
  );
};

EditableBox.defaultProps = {
  wrapperStyles: {
    p: '5px',
    height: 60,
  },
  textareaStyles: {
    fontSize: 14,
    height: '100%',
    color: G.getTheme('colors.dark.mainDark'),
  },
  boxStyles: {
    fontSize: 14,
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
};

export default EditableBox;
